import { BaseFieldClass } from './baseField.class'

import { formatDateHuman, parsePeriodValue } from '@/api/formatter'
import { IPeriodField } from '@/types/serverField.type'

export class PeriodFieldClass extends BaseFieldClass {
  declare fieldValue: string | null
  declare initialValue: string | null

  constructor (field: IPeriodField) {
    super(field)
    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value as string | null)
    this.fieldValue = this.prepareValue(value as string | null)
  }

  prepareValue (value: string | null): string {
    return value || ''
  }

  getValue (): Record<string, string> {
    return {
      [this.name]: this.fieldValue || ''
    }
  }

  isEmpty (): boolean {
    return !this.value
  }

  appendToFormData (formData: FormData): void {
    formData.append(this.name, this.fieldValue || '')
  }

  getFilterValue (): string | null {
    return this.fieldValue
  }

  getValueAsText (): string {
    const parsedDates = parsePeriodValue(this.fieldValue || '')

    if (parsedDates?.length === 2) {
      const from = formatDateHuman(parsedDates[0])
      const to = formatDateHuman(parsedDates[1])
      return from + ' — ' + to
    }

    return ''
  }
}
